export default __webpack_public_path__ + "static/media/heartRed.fb824694.svg";